<template>
<div >

    <Navbar></Navbar>
    <div class="main-content">
		<div class="container">

            <div class="import-box" style="max-width: 560px;" v-if="!import_success">
                <h2 class="mt-4 text-center">Precargar vehículos</h2>
                <p class="text-center">
                    Descargue el excel modelo, cargue los vehículos que desea precargar y vuelva a subir el excel ya cargado.
                </p>

                <div class="form-group text-left">
                    <label>CLIENTE</label>
                    <select class="form-control" v-model="form.clientId">
                        <option v-for="client in clients" :key="client.id" :value="client.id" >{{client.name}} ({{client.business_name}})</option>
                    </select>
                </div>
                <div class="invalid-feedback d-block" v-if="validation.hasError('form.clientId')">Seleccione un cliente</div>
                
                <div class="actions mt-4">
                    <a class="btn btn-icon btn-download" 
                        href="/exportables/precargar-vehiculos.php"
                        target="_blank">
                        <div class="icon icon-md icon-download-excel"></div>
                        Descargar archivo modelo
                    </a>
                    <div class="btn-icon p-0 text-center">
                        <xlsxTable
                            @on-select-file="handleSelectedFile" 
                            >
                            <div class="icon icon-md icon-upload margin-auto"></div>
                            Cargar vehículos
                        </xlsxTable>
                    </div>
                </div>
            </div>

            <Loader :show="loading || saving"></Loader>
            
            <div class="import-box" v-if="import_success">
                <h2 class="mt-4 text-center">Precargar vehículos</h2>
            </div>

            <div v-if="imported_cars.length>0">
                <div style="max-width:350px;margin:auto;">
                    <div class="alert alert-success" v-if="import_success">Carga completa! Se han importado {{imported_cars.length}} vehículos con éxito. <br>
                        <router-link tag="a" to="/cars" >Volver al listado de vehículos</router-link>
                    </div>
                    <div class="alert alert-warning" v-if="import_error">Se han encontrado errores en el archivo, por favor corríjalos y vuelva a cargarlo.</div>

                    <!-- <button type="submit" class="btn btn-primary btn-block" @click="save()">Importar</button> -->
                </div>

                <table class="table mt-4 mb-4" v-if="form.cars.length>0">
                    <tr class="table-head">
                        <td>Interno</td>
                        <td>Vehículo</td>
                        <td>Marca/Modelo</td>
                        <td>Ingreso</td>
                        <td>DUA</td>
                        <td>Estado</td>
                    </tr>
                    <tr v-for="item of imported_cars" :key="item.id" :class="{'error':item.error}" >
                        <td>
                            <div class="tc">
                                {{item.internal_number}}
                            </div>
                        </td>
                        <td>
                            <div class="tc">
                                <span v-b-tooltip.hover title="Número de chasis" class="text-primary">{{item.chassis_number}}</span>
                                <span v-b-tooltip.hover title="Número de motor" >Motor: {{item.motor_number}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="tc">
                                <span class="text-primary" v-b-tooltip.hover title="Marca">{{item.brand}}</span>
                                <span v-b-tooltip.hover title="Modelo y color" >{{item.model}} {{item.color}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="tc">
                                <span class="text-primary" v-b-tooltip.hover title="Depósito de destino">{{item.deposit}}</span>
                                <span v-b-tooltip.hover title="Fecha estimada de ingreso">{{item.admission_estimated_at | moment('DD-MM-YYYY')}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="tc">
                                <span class="text-primary" v-b-tooltip.hover title="DUA Importación">{{item.dua_dispatch}}</span>
                                <span v-b-tooltip.hover title="DUA Tránsito">{{item.dua_transit}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="tc text-danger" v-if="item.error" >
                                <span v-html="item.error"></span>
                            </div>
                            <div class="tc text-success" v-else >
                                <i class="fa fa-check"></i>
                            </div>
                        </td>
                    </tr>
                </table>

            </div>

        </div>
    </div>

</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import Navbar from '@/components/Navbar'
import xlsxTable from '@/components/VueXlsxTable'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
    name: "importPreloadCars",
    components:{
        Loader,
        Navbar,
        xlsxTable
    },
    mixins: [mixins],
    data() {
        return {
            loading: false,
            saving: false,
            form:{
                clientId: null,
                cars:[]
            },
            clients:[],
            imported_cars:[],
            import_error: false,
            import_success: false,
        }
    },
    beforeMount(){
		this.fetchData();
    },
    validators: {
		'form.clientId': function (value) {
			return Validator.value(value).required();
		},
        'form.cars': function (value) {
			return Validator.custom( () => {
                if(value.length<=0){
					return true
				}
			})
		},
	},
	methods:{
        handleSelectedFile (convertedData) {
            this.form.cars = []
            if(convertedData.body && convertedData.body.length>0){
               convertedData.body.forEach(loadedItem => {
                   var item = {
                        brand: loadedItem[convertedData.header[0]],
                        model: loadedItem[convertedData.header[1]],
                        color: loadedItem[convertedData.header[2]],
                        internal_number: loadedItem[convertedData.header[3]],
                        chassis_number: loadedItem[convertedData.header[4]],
                        motor_number: loadedItem[convertedData.header[5]],
                        deposit: loadedItem[convertedData.header[6]],
                        category: loadedItem[convertedData.header[7]],
                        admission_estimated_at: loadedItem[convertedData.header[8]],
                        dua_transit: loadedItem[convertedData.header[9]],
                        dua_dispatch: loadedItem[convertedData.header[10]],
                   }
                   this.form.cars.push(item)
                }) 
                this.save()
            }else{
                this.$toast.error('Archivo vacío o invalido')
            }
        },
        fetchData(){
            this.loading = true
			this.$apollo.query({
				query: gql`query  {
					clientsAll {
						id
                        name
                        business_name
					}
				}`,
			})
			.then((data) => {
                this.clients = data.data.clientsAll
                this.loading = false
			});
        },
		async save () {
			if(!this.saving && await this.checkValidation() ) {
                this.saving = true
                this.$apollo.mutate({
                    mutation: gql`mutation ( $data:PreloadCarsInput! ){
                        preloadCars( data: $data) {
                            brand_id
                            brand
                            model_id
                            model
                            color
                            chassis_number
                            category_id
                            category
                            deposit
                            dua_dispatch
                            dua_transit
                            internal_number
                            motor_number
                            admission_estimated_at
                            error
                        }
                    }`,
                    variables: {
                        data: {
                            clientId: this.form.clientId,
                            cars: this.form.cars
                        }
                    }
                })
                .then((data) => {
                    this.imported_cars = data.data.preloadCars
                    this.import_error = false
                    this.import_success = false

                    if(this.imported_cars.length>0){
                        this.imported_cars.forEach(car => {
                            if(car.error){
                                this.import_error = true
                            }
                        })
                    }

                    if(!this.import_error){
                        this.import_success = true;
                    }
                    this.saving = false
                })
                .catch( (error) => {
                    this.errors = this.parseGQLErrors(error)
                    this.$toast.error('Error!')
                    this.saving = false
                })
            }
		},
	}
};
</script>

<style scoped lang="scss">
.btn{
    position:relative;
}

    

.error{
    background-color: #f5d9dc !important;
}

</style>
